import { HStack, Stack } from "@chakra-ui/react";
import LargeContainer from "../../Components/Container/largeContainer";
import { ReactComponent as CheckCircle } from "../../assets/check-circle.svg";
import styles from "../BookingConfirmed/confirm.css";
import SmallFlexContainer from "../../Components/Container/smallFlexContainer";
import CustomButton from "../../Components/Button/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import SubHeading from "../../Components/Text/subHeading";

export default function BookingConfirmed() {
  const location = useLocation();
  const navigate = useNavigate();

  const {
    selectedSlot,
    customerId,
    phoneNumber,
    maxDate,
    selectedDate,
    showAmendButton,
  } = location?.state || {};

  const navigateAmend = () => {
    navigate("/update-booking", {
      state: { maxDate, customerId, phoneNumber },
    });
  };

  const navigateExit = () => {
    navigate("/", { replace: true });
  };

  const formattedBookingDate = selectedDate
    ? selectedDate.toDateString().split(" ").slice(0, 4).join(" ")
    : "";

  return (
    <LargeContainer minH={"100vh"}>
      <SmallFlexContainer alignItems="center" margin="50px">
        <Stack bg="white" boxShadow="lg" p="32px" rounded={5}>
          <HStack bg="white" p="32px" rounded={5}>
            <CheckCircle />
            <b className={styles.bookingConfirmed}>Booking Confirmed</b>
          </HStack>
          <SmallFlexContainer
            alignItems="center"
            bg="white"
            boxShadow="lg"
            p="10px"
            border="1px solid #E5E5E5"
          >
            <SubHeading
              subHeadingLabel={"Date: " + formattedBookingDate}
              fontSize="10px"
            ></SubHeading>
            <SubHeading
              subHeadingLabel={"Slot: " + selectedSlot.slotTime}
              fontSize="10px"
              marginTop="10px"
            ></SubHeading>
          </SmallFlexContainer>
          <SmallFlexContainer margin="20px">
            {showAmendButton && (
              <CustomButton
                buttonLabel="Amend Booking"
                marginTop="20px"
                onClick={navigateAmend}
              ></CustomButton>
            )}
            <CustomButton
              buttonLabel="Exit"
              marginTop="20px"
              onClick={navigateExit}
            ></CustomButton>
          </SmallFlexContainer>
        </Stack>
      </SmallFlexContainer>
    </LargeContainer>
  );
}
